import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const PublishedBadge = ({value}) => (
    <span className={classNames('badge badge-pill', {'badge-primary': value, 'badge-warning': !value})}>
        {value ?
            <FormattedMessage {...messages.survey.published} /> :
            <FormattedMessage {...messages.survey.unpublished} />
        }
    </span>
);

PublishedBadge.propTypes = {
    value: PropTypes.bool,
};

export default PublishedBadge;
